import { getIdToken } from '../../getIdToken';
import { parseBackendIntegrationName } from './types';

/**
 * Fetch status of all integrations for current user
 * @returns {Promise<Array>}
 */
export async function getZohoStatus() {
  const token = await getIdToken();
  const url = `${process.env.REACT_APP_INTEGRATIONS_API_URL}/integrations/status`;
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  if (!response.ok) throw new Error('Failed to fetch status');
  return response.json();
}

/**
 * Fetch status of all integrations and format them
 * Returns array of integration status objects with parsed provider/product info
 * @returns {Promise<Array>}
 */
export async function getIntegrationStatuses() {
  const statuses = await getZohoStatus();
  return statuses.map(status => ({
    ...status,
    integrationInfo: parseBackendIntegrationName(status.integrationName),
  }));
}

/**
 * Check if a specific integration is connected
 * @param {string} provider - Provider name
 * @param {string} [product] - Product name (optional)
 * @returns {Promise<boolean>}
 */
export async function isIntegrationConnected(provider, product) {
  const statuses = await getIntegrationStatuses();
  
  return statuses.some(status => {
    if (!status.integrationInfo) return false;
    
    if (product) {
      return (
        status.integrationInfo.provider === provider &&
        status.integrationInfo.product === product &&
        status.connected
      );
    }
    
    return (
      status.integrationInfo.provider === provider &&
      status.connected
    );
  });
}

